import { createSlice } from "@reduxjs/toolkit";
import endScreenState from "../../../constants/endScreen/endScreenState";

// Create a Redux slice for the 'End Screen' portion of the state
export const endScreenSlice = createSlice({
  name: "endScreen", // The name of the slice
  initialState: endScreenState, // Initial state for End Screen
  reducers: {
    // Action to set End Screen
    setEndScreen: (state, action) => {
      state.data = action.payload;
    },
    // Action to set End Screen Etc data
    setEndScreenEtc: (state, action) => {
      state.etc = action.payload;
    },
    // Action to set End Screen step
    setEndScreenStep: (state, action) => {
      state.etc.endScreenStep = action.payload;
    },
    // Action to set the next End Screen step
    setNextEndScreenStep: (state) => {
      state.etc.endScreenStep = state.etc.endScreenStep + 1;
    },
    // Action to set the previous End Screen step
    setPrevEndScreenStep: (state) => {
      state.etc.endScreenStep = state.etc.endScreenStep - 1;
    },
    // Action to set whether End Screen is submittable
    setIsEndScreenSubmittable: (state, action) => {
      state.etc.isEndScreenSubmittable = action.payload;
    },
  },
});

// Export the action creators
export const {
  setEndScreen,
  setEndScreenEtc,
  setEndScreenStep,
  setNextEndScreenStep,
  setPrevEndScreenStep,
  setIsEndScreenSubmittable,
} = endScreenSlice.actions;

// Export the reducer
export default endScreenSlice.reducer;
